import { Layer, Group } from "react-konva";
import Seat from "./Seat/Seat";
import React from "react";

const Seats = React.memo(
  ({ data }) => {
    return (
      <Layer>
        {data?.rows &&
          Object.values(data.rows).map((row) => (
            <Group key={row.rowId}>
              {row.seats.map((seatId) => {
                const seat = data.seats[seatId];
                return (
                  <Seat
                    key={seat.seatId}
                    seat={seat}
                  />
                );
              })}
            </Group>
          ))}
      </Layer>
    );
  }
);

export default Seats;
